import { Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledFeaturePanelContainer = styled(Box)(({ theme }) => ({
  margin: "10px 0 20px 0",
  [theme.breakpoints.up("mobile")]: {
    margin: "15px 0 30px 0",
  },
}));

const SHARED_CONTAINER_STYLES = (theme) => ({
  marginBottom: 20,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 30,
  },
});

export const StyledCategoryRowContainer = styled(Box)(({ theme }) => ({
  ...SHARED_CONTAINER_STYLES(theme),
}));

export const StyledModuleMenuContainer = styled(Container)(({ theme }) => ({
  ...SHARED_CONTAINER_STYLES(theme),
}));
